import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { RouterBreadcrumbState } from '@shared/store/router/reducers/router-breadcrumbs.reducers';
import * as fromBreadCrumbs from './router-breadcrumbs.reducers';

export interface RouterState {
  routerBreadcrumbs: RouterBreadcrumbState;
}

export const reducers: ActionReducerMap<RouterState> = {
  routerBreadcrumbs: fromBreadCrumbs.reducer,
};

export const getRouterState = createFeatureSelector<RouterState>('router-state');
